import { render, staticRenderFns } from "./SamSelectList.vue?vue&type=template&id=118b1956&scoped=true&"
import script from "./SamSelectList.vue?vue&type=script&lang=js&"
export * from "./SamSelectList.vue?vue&type=script&lang=js&"
import style0 from "./SamSelectList.vue?vue&type=style&index=0&id=118b1956&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118b1956",
  null
  
)

export default component.exports